import React, { useState, useEffect, createContext } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { LD_BASE_URL, LD_CLIENT_SIDE_ID, LD_TEST_OBJECT } from '@/config';

import { TLaunchDarklyProps, TParams } from './types';

export const LaunchDarklyContext = createContext({} as TLaunchDarklyProps);

const LaunchDarklyProvider = ({ children }: TParams): JSX.Element | null => {
  const [optinURL, setOptinURL] = useState('');
  const [ruleURL, setRuleURL] = useState('');
  const [portalID, setPortalID] = useState('');
  const [interactionsURL, setInteractionsURL] = useState('');

  const [isVisible, setVisible] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleEnvironments = (ldclient: any) => {
    if (/localhost/.test(window.location.host)) {
      return LD_TEST_OBJECT;
    }

    return ldclient.variation('api-data', false);
  };

  useEffect(() => {
    const user = { key: window.location.origin };

    const ldclient = LDClient.initialize(LD_CLIENT_SIDE_ID, user, {
      baseUrl: LD_BASE_URL,
      sendEvents: false,
    });

    ldclient.on('ready', () => {
      const data = handleEnvironments(ldclient);
      setOptinURL(data.BASE_URL);
      setRuleURL(data.APP_CONFIG_URL);
      setPortalID(data.LIFERAY6_SITE_ID);
      setInteractionsURL(`${data.RECSYS_ENGINE_API}/v2`);
      setVisible(true);
    });
  }, []);

  if (isVisible) {
    return (
      <LaunchDarklyContext.Provider
        value={{
          optinURL,
          ruleURL,
          portalID,
          interactionsURL,
        }}
      >
        {children}
      </LaunchDarklyContext.Provider>
    );
  }

  return null;
};

export default LaunchDarklyProvider;
